export class PropertyAnimation {
  private currentAnimations: RunningPropertyAnimation[];

  constructor(
    private animatedObject: AnimatableObject,
    private doneCallback: PropertyAnimationCallback,
    private stepCallback?: PropertyAnimationCallback,
  ) {
    animatedObject.animatedProperties = this;
    this.currentAnimations = [];
  }

  public animate(propAnims: PropertyAnimationDefinition[]) {
    this.animatedObject.animatedProperties = this;

    let animations = new Array<RunningPropertyAnimation>();

    for (let propAnim of propAnims) {
      let delta =
        propAnim.index === undefined
          ? propAnim.value - this.animatedObject[propAnim.property]
          : propAnim.value - this.animatedObject[propAnim.property][propAnim.index];

      let steps = Math.ceil(Math.abs(delta) / propAnim.speed);

      animations.push({
        index: propAnim.index,
        property: propAnim.property,
        modifyValue: delta / steps,
        targetValue: propAnim.value,
        totalSteps: steps,
        stepsDone: 0,
      });
    }
    this.currentAnimations = animations;
  }

  public step() {
    let any = false;
    for (let animation of this.currentAnimations) {
      if (animation.stepsDone < animation.totalSteps) {
        animation.stepsDone++;

        if (animation.index === undefined) {
          this.animatedObject[animation.property] += animation.modifyValue;
        } else {
          this.animatedObject[animation.property][animation.index] += animation.modifyValue;
        }
        any = true;

        if (animation.stepsDone == animation.totalSteps) {
          if (animation.index === undefined) {
            this.animatedObject[animation.property] = animation.targetValue;
          } else {
            this.animatedObject[animation.property][animation.index] = animation.targetValue;
          }

          if (this.doneCallback) {
            this.doneCallback(this, this.animatedObject);
          }
        }
      }
    }

    if (!any) {
      this.animatedObject.animatedProperties = undefined;
    } else {
      if (this.stepCallback) {
        this.stepCallback(this, this.animatedObject);
      }
    }
  }
}

type AnimatableObject = {
  animatedProperties?: PropertyAnimation;
  [key: string]: number | number[] | any;
};

type PropertyAnimationDefinition = {
  property: string;
  value: number;
  index?: number;
  speed: number;
};

type RunningPropertyAnimation = {
  index?: number;
  property: string;
  modifyValue: number;
  targetValue: number;
  totalSteps: number;
  stepsDone: number;
};

type PropertyAnimationCallback = (anim: PropertyAnimation, animatedObject: any) => void;
